import { Button, Form } from 'antd';
import '../ViewWorkflowModal.less';
import { useContext } from 'react';
import { ContextApp } from '../../../contexts/ContextApp';

interface FinalStepBtnGroupProps {
  onCancel?: () => void;
  nextActivityData: {
    approval: string;
    decline: string;
  };
  handleStepZeroSubmit: (
    isRejectedValue: boolean,
    nextTask: string,
    finalize?: boolean,
  ) => Promise<void>;
}

const FinalStepBtnGroup = (props: FinalStepBtnGroupProps) => {
  const { onCancel, handleStepZeroSubmit, nextActivityData } = props;
  const { t } = useContext(ContextApp);
  return (
    <>
      <Form.Item id="button">
        <div className="button-container">
          <Button onClick={onCancel}>{t('action.cancel')}</Button>

          <Button
            type="primary"
            htmlType="button"
            onClick={async () => {
              try {
                handleStepZeroSubmit(false, nextActivityData.approval, true);
              } catch (err) {}
            }}
          >
            Guardar y Finalizar
          </Button>
        </div>
      </Form.Item>
    </>
  );
};
export default FinalStepBtnGroup;
